import config from '../config';
import React from 'react';
import NavDrawer from '../components/navdrawer';
import SEO from '../components/seo';
import '../stylesheets/main.css';
import '../stylesheets/speaker.css';
import { shapes } from '.';

export default () => (
  <>
    <SEO title='Devfest' />
    <NavDrawer>
      <main>
        <section>
          {config.content.cohorts.map((cohort, index) => (
            <>
              <h3 className={'center'}>Day {index + 1} Speakers</h3>

              <p className={'center'}>{cohort.desc}</p>
              <a className={'maplink'} href='https://goo.gl/maps/ZfHWuRypyLRnKRxm6' target={'_blank'}>
                Show On Map &nbsp;
                <i class='fa fa-map mapicon' aria-hidden='true'></i>
              </a>
              <div className={'speaker-grid'}>
                {cohort.speakers.map((speaker, index) => (
                  <div className={'speaker-container-landscape'} key={index}>
                    <div className={'shape'}>{shapes[index % shapes.length]}</div>
                    <div className={'dp-container'}>
                      <img alt={speaker.name} className={'speaker-dp'} src={speaker.dp} />
                    </div>
                    <div className={'speaker-info'}>
                      <h3>{speaker.name}</h3>
                      <h4>{speaker.designation}</h4>
                      <div className={'social-platter'}>
                        {speaker.twitter && (
                          <div>
                            <a href={speaker.twitter} target={'_blank'}>
                              <i className='fab fa-twitter' />
                            </a>
                          </div>
                        )}
                        {speaker.linkedin && (
                          <div>
                            <a href={speaker.linkedin} target={'_blank'}>
                              <i className='fab fa-linkedin' />
                            </a>
                          </div>
                        )}
                      </div>
                      <p className={'speaker-desc'}>{speaker.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <br />
              <br />
            </>
          ))}
        </section>
      </main>
    </NavDrawer>
  </>
);
